import { useEffect, useState } from 'react';
import './FinalContentForPart.scss';
import api, { FragmentFinalContent } from '../../../../../../utils/api';
import { useNavigate } from "react-router";


interface FinalContentForPartProps{
    projectId: string
    partId: string
}
function FinalContentForPart({projectId, partId}: FinalContentForPartProps) {
    const [fragments, setFragments] = useState<FragmentFinalContent[]>([])
    const navigate = useNavigate()
    const loadFragments = () => {
        api.getFinalContentForPart(projectId, partId)
        .then(fragments => setFragments(fragments))
    }
    useEffect(loadFragments, []);
    
    return <div className='final-content-for-part'>
        {fragments.map(fragment => <p 
            className='fragment' 
            key={fragment.id} 
            //onClick={() => navigate(`/projects/${projectId}/parts/${partId}/fragments/${fragment.id}`)}
            >
                {fragment.content.split("\n").map(function(item, idx) {
                    return (
                        <span key={idx}>
                            {item}
                            <br/>
                        </span>
                    )
                })}
        </p>)}
    </div>;
};

export default FinalContentForPart;